import { IRespostaFuncao } from "src/integracoes/modelos/funcoes";
import { del, get, patch, post } from "../../api/api";
import { IQueryRelatorio, IRelatorio } from "../modelos/IConstrutor";

// Obtem tabelas relatorios iniciais
export const obtemTabelasRelatorio = async () => {
  return await get<IRespostaFuncao<any[]>>(`/relatorios/obtem-relatorios/`);
};

// Executa Consulta Relatorio iniciais e completos
export const executarConsultaRelatorio = async (
  relatorio: IQueryRelatorio,
  valor: number
): Promise<IRespostaFuncao<any>> => {
  return await post<IRespostaFuncao<any>>(
    `/relatorios/executar-consulta?limit=${valor}`,
    relatorio
  );
};

// Criar relatorio personalizado
export const criarRelatorioPersonalizado = async (
  relatorio: IRelatorio
): Promise<IRespostaFuncao<any>> => {
  return await post<IRespostaFuncao<any>>(
    `/relatorios/cria-relatorio`,
    relatorio
  );
};

// Editar relatorio personalizado
export const editarRelatorioPersonalizado = async (
  id: string,
  relatorio: IRelatorio
): Promise<IRespostaFuncao<any>> => {
  return await patch<IRespostaFuncao<any>>(
    `/relatorios/${id}/atualiza-relatorio`,
    relatorio
  );
};

// Excluir relatorio personalizado
export const excluiRelatorioPersonalizado = async (
  id: string
): Promise<IRespostaFuncao<any>> => {
  return await del<IRespostaFuncao<any>>(
    `/relatorios/${id}/remove-relatorio`
  );
};

